/**
 * Breakpoints values and REM to PX conversion
 *
 */


// REM to PX conversion
export const rem = (remValue) => {
    const remVal = typeof remValue === 'string' ? remValue.replace('rem', '') : remValue;
    const baseFontSize = window.getComputedStyle(document.documentElement)['font-size'].replace('px', '');
    return parseFloat(remVal, 10) * baseFontSize;
};


// Same array as the SCSS one but in this case all the values are offset by 1
// because the initial SCSS breakpoints is Mobile UP and our JS plugins are Desktop DOWN.
// don't change this without changing the SCSS breakpoints as well
export const breakpoints = {
    xs: 25,
    sm: 40,
    md: 52,
    lg: 66,
    xl: 999,
};


// Breakpoint key to PX value
export const breakpointToPx = breakpoint => rem(breakpoints[breakpoint]);
